import { useState } from 'react';
import {
  QUERY_GET_INPUT_DATA_OF_PERSON_AND_TESTITEM,
  removeDataPoint
} from 'services/aws/growthtracker-query';
import { useLazyQuery } from '@apollo/client';

const usePersonTestItemInputData = () => {
  const [personInputData, setPersonInputData] = useState(null);
  const [fetchInputDataOfSporter, { loading, error, data, refetch }] =
    useLazyQuery(QUERY_GET_INPUT_DATA_OF_PERSON_AND_TESTITEM);

  const fetchInputData = async ({ personId, testItemId, testId }) => {
    const { data } = await fetchInputDataOfSporter({
      variables: {
        personId,
        testItemId,
        testId
      },
      fetchPolicy: 'cache-and-network',
      skip: !personId && !testItemId && !testId
    });

    if (data?.getInputData) {
      setPersonInputData(data.getInputData);
      return data.getInputData;
    }
  };

  const deleteDataPoint = async id => {
    return new Promise(async resolve => {
      const result = await removeDataPoint(id);
      if (result) {
        resolve(true);
      }
    });
  };

  return {
    fetchInputData,
    deleteDataPoint,
    personInputData,
    loading,
    error,
    refetch
  };
};

export default usePersonTestItemInputData;
